/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import "./Headline.scss";
import { cn } from "tailwind-variants";

export default function Headline({ largeGap, children, slots, ...restProps }: any) {
  return (
    <div
      {...restProps}
      className={cn("scope-20b5d5db", restProps.className, "headline", {
        "headline--large-gap": largeGap
      })}
    >
      {children}
      <div className="headline__captions scope-20b5d5db">
        <div className="headline__title scope-20b5d5db">{slots?.title?.()}</div>
        <div className="headline__subtitle scope-20b5d5db">{slots?.subtitle?.()}</div>
      </div>
    </div>
  );
}
